
import './App.css';
import Advice from './component/Advice';

function App() {
  return (
    <div className="App">
      <Advice />
    </div>
  );
}

export default App;
